import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

// Find all widget divs
const WidgetDivs = document.querySelectorAll(".auction_widget");

// Inject our React App into each
WidgetDivs.forEach((Div) => {
  ReactDOM.render(
    <>
      <App domElement={Div} />
    </>,
    Div
  );
});

